<template>
  <div class="edit-commodityGoods-campus" data-test="edit-commodityGoods-campus">
    <div class="wrap">
      <van-cell
        clickable
        required
        is-link
        title="售卖校区"
        title-class="tctil"
        :border="false"
        @click.stop="choiceCampus()">
        <template>
          <div v-if="campusList.length>0">
            <div class="van-ellipsis vu">
              {{ campusText }}
            </div>
            <span 
              v-if="campusList.length > 1"
              @click.stop="showPopup1 = true"
              style="color: var(--tlc); font-size: var(--fs-md)">
              查看已选校区
            </span>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>
      <template v-if="campusList.length>0">
        <div v-for="(item,index) in campusList" :key="index" class="item-list">
          <van-cell
            class="itil"
            :title="item.name"
            :border="false"
            style="background: rgba(var(--g2-rgb), 0.3)"
            >
            <template #right-icon>
              <div class="del" @click="delCampus(index,item)">
                <van-icon name="delete-o" color="var(--g6)" size="18"/>
              </div>
            </template>
          </van-cell>
          <template v-for="(pit,idx) in commodityGoodsStockMap[item.id]">
            <van-cell
              :title="pit.priceName"
              title-class="tctil"
              :key="idx"
            >
              <template>
                <div class="num">
                  <van-stepper
                    v-model.number="pit.availableSaleStock"
                    integer
                    input-width="60"
                    min="0"
                    max="999999"
                    :allow-empty="true"
                    default-value=""
                  />
                </div>
                <div>在售数量：{{pit.stock}}个&nbsp;可售库存：{{pit.surplusStock}}个</div>
              </template>
            </van-cell>
          </template>
        </div>
      </template>
    </div>
    <div class="footer">
      <van-button block square round type="primary" @click="toSave" data-test="edit-commodityGoods-campus-save-btn">保存</van-button>
    </div>

    <!-- 已选校区 -->
    <van-action-sheet v-model="showPopup1" :round="false" get-container="body">
      <div class="show-choosed-popup">
        <div class="head">
          <div class="til">已选校区({{ campusList.length }})</div>
          <div class="clearbtn" @click="clearCampus">清空</div>
        </div>
        <div class="linewrap">
          <div
            class="line van-hairline--bottom"
            v-for="(campus, index) in campusList"
            :key="campus.id"
          >
            <div class="l">
              <div class="name">{{ campus.name }}</div>
            </div>
            <div class="r">
              <van-icon name="clear" color="var(--g6)" @click="delCampus(index, campus)" />
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { openMallCampusFilter } from "./filtrate/index.js";

export default {
  name: 'edit-commodityGoods-campus',
  data() {
    return {
      pageTitle: '售卖校区',
      commodityId: '',
      showPopup1: false,
      campusIds: [],
      campusList: [], //已选的校区
      campusListAll: [], //所有校区
      commodityGoodsStockMap: {},
    }
  },
  computed: {
    campusText() {
      if (this.campusList.length == 1) {
        return `${this.campusList[0].name}`;
      } else if (this.campusList.length > 1) {
        return `已选${this.campusList.length}个校区`;
      } else {
        return '';
      }
    },
  },
  methods: {
    async getShelfSaleCampusStockList() { // 获取已上架的校区的库存
      this.showLoading();
      let res = await this.$api.getShelfSaleCampusStockList({
        goodsId: this.id,
        commodityId: this.commodityId,
        campusIds: this.campusIds,
      });
      vant.Toast.clear();

      let preMapKey = Object.keys(this.commodityGoodsStockMap);
      let newMapKey = Object.keys(res.data.commodityGoodsStockMap);
      this.add_ele(newMapKey,preMapKey).forEach(key=>{
        this.$set(this.commodityGoodsStockMap, key);
        let arr = res.data.commodityGoodsStockMap[key].map(item=>{
          return {
            ...item,
            availableSaleStock: item.stock < 0 ? 0 : item.stock 
          }
        });
        this.commodityGoodsStockMap[key] = arr;
      });
      this.del_ele(newMapKey,preMapKey).forEach(key=>{
        delete this.commodityGoodsStockMap[key];
      });
    },
    async init() { // 初始化获取已上架的校区
      this.showLoading();
      let res = await this.$api.shelfSaleCampusList({
        // 要获取的校区列表类型， 1：机构下所有校区， 2：个人的授权校区
        type: 2,
        commodityId: this.commodityId
      });
      vant.Toast.clear();
      this.campusIds = res.data.filter(v=>v.mallStatus).map(v=>v.id);
      this.campusList = res.data.filter(v=>v.mallStatus);
      this.campusListAll = res.data;
      this.getShelfSaleCampusStockList();
    },
    async choiceCampus() {
      let res = await openMallCampusFilter({
        selectType: 2,
        ids: this.campusIds,
        params: {
          commodityId: this.commodityId,
        }
      });
      this.campusIds = res.ids;
      this.campusList = res.list;
      this.campusListAll = res.listAll;
      this.getShelfSaleCampusStockList();
    },
    clearCampus() {
      this.campusIds = [];
      this.campusList = [];
      this.showPopup1 = false;
    },
    delCampus(index, campus) {
      this.campusIds.splice(index, 1);
      this.campusList.splice(index, 1);
      this.campusListAll.forEach(i=>{
        if (i.id == campus.id) {
          i.mallStatus = false;
        }
      })
      if (this.campusList.length == 0) {
        this.showPopup1 = false;
      }
    },
    toSave() {
      if (!this.campusIds.length) {
        this.$toast('请选择售卖校区');
        return;
      }
      let commodityGoodsStockList = [];
      this.campusList.forEach(key => {
        let cid = key.id;
        if (this.commodityGoodsStockMap[cid]) {
          let arr = this.commodityGoodsStockMap[cid].map(item=>{
            return {
              campusId: item.campusId,
              commodityId: item.commodityId,
              priceItemId: item.priceItemId,
              surplusStock: item.availableSaleStock
            }
          });
          commodityGoodsStockList = commodityGoodsStockList.concat(arr);
        }
      });
      let nullLength = commodityGoodsStockList.filter(item => String(item.surplusStock).trim().length == 0);
      if (nullLength.length > 0) {
        vant.Toast.fail('请输入库存');
        return false;
      }
      this.showLoading();
      this.$api.updateCommoditySaleCampus({
        id: this.id,
        commodityType: 0, // 0 物品 1 班级 2 课程
        commodityAvailableCampusRos: this.campusListAll.map(i=>{
          return{
            id: i.id,
            mallStatus: i.mallStatus
          }
        }),
        commodityGoodsStockList: commodityGoodsStockList,
      }).then(res1=> {
          vant.Toast.clear();
        if (res1.code == 200) {
          vant.Toast.success('更新售卖校区成功');
          app.vue.$emit("refresh-product-list",0);
          this.$router.back();
        } else if (res1.code === 830000028) { // 判断班级所在校区或物品的售卖校区是否有启用状态的收款商户
          this.$dialog.confirm({
            message: `商品的售卖校区（${res1.msg}）还没有设置线上收款商户，无法上架商品。请先设置收款商户后再上架`,
            cancelButtonText: '取消',
            confirmButtonText: '设置线上收款商户',
          }).then(async () => {
            this.$router.push(`/sf/set/channel`);
          });
        }
      })
    },
    add_ele(newArr,oldArr){
      return newArr.filter(function(i){
          return oldArr.indexOf(i) === -1
      })
    },
    del_ele(newArr,oldArr){
      return oldArr.filter(function(i){
          return newArr.indexOf(i) === -1
      })
    }
  },
  created() {
    let query = this.$route.query;
    this.id = query.id;
    this.commodityId = query.commodityId;
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.edit-commodityGoods-campus {
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
    .tctil {
      flex: none;
      width: 80px;
    }
    .item-list {
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
      border-radius: var(--radius-sm);
      overflow: hidden;
      .van-cell {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        .van-icon-circle,
        .van-icon-checked {
          vertical-align: middle;
          margin-right: calc(var(--gap) * 4);
        }
      }
    }
  }
  .footer {
    height: 50px;
    background: var(--white);
    padding: 5px 16px;
    display: flex;
    .van-button {
      height: 40px;
    }
  }
}

.show-choosed-popup {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .linewrap {
    padding: 0 calc(var(--gap) * 16);
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) 0;
      .l {
        .name {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
        }
        .desc {
          margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
      }
    }
  }
}
</style>